// extracted by mini-css-extract-plugin
export var btn_consent = "cookieSettings-module--btn_consent--88fb4";
export var btn_customize = "cookieSettings-module--btn_customize--93e45";
export var btn_decline = "cookieSettings-module--btn_decline--34aa2";
export var button_container = "cookieSettings-module--button_container--917fb";
export var cookie_setting_container = "cookieSettings-module--cookie_setting_container--595ee";
export var setting_container = "cookieSettings-module--setting_container--56c84";